;(function () {
  'use strict'

  angular
    .module('contrast.empty-state')
    .factory('csEmptyStateConfig', ['$translate', csEmptyStateConfig])

  function csEmptyStateConfig($translate) {
    var translGlobal = {
      detail_applicationFeatures_youCanGetMore: $translate.instant(
        'detail_applicationFeatures_youCanGetMore'
      ),
      detail_applicationFeatures_unlicensedApp: $translate.instant(
        'detail_applicationFeatures_unlicensedApp'
      ),
      detail_applicationFeatures_urlActivity_unavailable: $translate.instant(
        'detail_applicationFeatures_urlActivity_unavailable'
      )
    }

    var config = {
      appAttacks: {
        icon: 'beachAccess',
        iconSize: '58',
        primaryMsg: $translate.instant('detail_protectFeatures_noAttacks'),
        secondaryMsg: $translate.instant(
          'detail_protectFeatures_attackDataPolicy',
          { href: 'https://docs.contrastsecurity.com/en/attacks.html' }
        ),
        extraDetails: 'views/common/protect_server_restart.html'
      },
      appAttacksNoProtect: {
        icon: 'shield',
        iconSize: '58',
        primaryMsg: $translate.instant(
          'detail_applicationFeatures_youCanGetMore'
        ),
        secondaryMsg: $translate.instant(
          'detail_applicationFeatures_notUsingProtect'
        )
      },
      serverAttacks: {
        icon: 'beachAccess',
        iconSize: '58',
        primaryMsg: $translate.instant('detail_protectFeatures_noAttacks'),
        secondaryMsg: $translate.instant(
          'detail_protectFeatures_attackDataPolicy',
          { href: 'https://docs.contrastsecurity.com/en/attacks.html' }
        ),
        extraDetails: 'views/common/protect_server_restart.html'
      },
      serverAttacksNoProtect: {
        icon: 'shield',
        iconSize: '58',
        primaryMsg: $translate.instant(
          'detail_applicationFeatures_youCanGetMore'
        ),
        secondaryMsg: $translate.instant(
          'detail_serverFeatures_notUsingProtect'
        )
      },
      serverVulns: {
        icon: 'thumbsUp',
        iconSize: '58',
        primaryMsg: 'This server is vulnerability free.',
        secondaryMsg: 'Now that is impressive!'
      },
      serverVulnsNoAssess: {
        icon: 'clipboard',
        iconSize: '58',
        primaryMsg: $translate.instant(
          'detail_applicationFeatures_youCanGetMore'
        ),
        secondaryMsg:
          "This server is not using Assessment, which means we've got nothing to show you."
      },
      serverVulnsAssessPending: {
        icon: 'clipboard',
        iconSize: '58',
        primaryMsg: 'Assessment is coming!',
        secondaryMsg:
          'This server is waiting for restart to begin seeing vulnerabilities.'
      },
      appActivityNone: {
        icon: 'cobweb',
        iconSize: '58',
        primaryMsg:
          translGlobal.detail_applicationFeatures_urlActivity_unavailable,
        extraDetails: 'views/applications/coverage_none.html'
      },
      serverNoProperties: {
        icon: 'error',
        iconSize: '58',
        primaryMsg: 'Nothing to see here...',
        secondaryMsg:
          'The server is still collecting this information. <br/> Try back another time.'
      }
    }

    var service = {
      has: has,
      get: get
    }

    return service

    function has(key) {
      return config.hasOwnProperty(key)
    }

    function get(key) {
      return config[key]
    }
  }
})()
